export const FETCH_USER_DATA_BEGIN = "FETCH_USER_DATA_BEGIN";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_FAILURE = "FETCH_USER_DATA_FAILURE";
export const SET_USER_LOGOUT = "SET_USER_LOGOUT";

export const SET_AUTH_STATUS = "SET_AUTH_STATUS";
